import React from 'react';
import classes from './Accordion.module.css';
import chevronRight from '../../../assets/icons/chevron-right-2.svg';
import chevronDown from '../../../assets/icons/chevron-down.svg';

type Props = {
  header: React.ReactNode;
  children?: React.ReactNode;
  defaultOpen?: boolean;
  containerStyle?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  disableExpand?: boolean;
};

const Accordion: React.FC<Props> = ({
  header,
  children,
  defaultOpen = false,
  containerStyle = {},
  headerStyle = {},
  bodyStyle = {},
  disableExpand = false,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(defaultOpen);

  return (
    <div className={classes.container} style={containerStyle}>
      <div
        className={`${classes.header} ${children ? classes.hasChildren : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        style={headerStyle}
      >
        <div>{header}</div>
        {children && !disableExpand && (
          <img
            className={classes.chevron}
            alt={'chevron'}
            src={isOpen ? chevronDown : chevronRight}
          />
        )}
      </div>
      {children && !disableExpand && (
        <div
          className={`${classes.body} ${isOpen ? classes.bodyOpen : ''}`}
          style={isOpen ? bodyStyle : {}}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export { Accordion };
